import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { HomeMobile } from "@features/home/mobile/HomeMobile/HomeMobile";
import { HomeMobileReasonsToLove } from "@features/home/mobile/HomeMobileReasonsToLove/HomeMobileReasonsToLove";
import { HomeMobileSwitchEasy } from "@features/home/mobile/HomeMobileSwitchEasy/HomeMobileSwitchEasy";
import { HomeMobileFrequentlyAskedQuestions } from "@features/home/mobile/HomeMobileFrequentlyAskedQuestions/HomeMobileFrequentlyAskedQuestions";
import { EServiceGroup, ROUTES } from "@constants";
import { HomeMarketingInformationBanner } from "@features/home/common/HomeMarketingInformationBanner/HomeMarketingInformationBanner";
import { HomeStickyBanner } from "@features/home/common/HomeStickyBanner/HomeStickyBanner";
import { useHomeMobilePage } from "./useHomeMobilePage";
import { BUTTON_IDS } from "@features/dataLayer/buttonIds";
import { Helmet } from "react-helmet";
import { getOfferPrice } from "@utils/offerUtils";

export const HomeMobilePage = () => {
    const { t } = useTranslation("home");
    const { push } = useHistory();
    const {
        broadbandOffer,
        mobileOffer,
        broadbandCartOffer,
        hasMobileOfferInCart,
        mobileOfferCount,
        hasBroadbandOfferInCart,
        isBroadbandSidePanelOpen,
        closeBroadbandSidePanel,
        isLoading,
        error,
        orderAuthorization,
        handleAddMobileOffer,
        handleAddBroadbandOffer,
        handleDeleteBroadbandOffer,
        addBroadbandOfferState,
        retry,
        handleBannerButtonClick,
        isTabletOrDesktop,
        isMobile,
    } = useHomeMobilePage();

    const renderHomeStickyBanner = () =>
        mobileOffer &&
        !isBroadbandSidePanelOpen && (
            <HomeStickyBanner
                buttonId={BUTTON_IDS.MOBILE_FLOW.STICKY[hasMobileOfferInCart ? "VIEW_BASKET" : "BUY_NOW"]}
                buttonLabel={t(hasMobileOfferInCart ? "viewYourBasket" : "buyNow")}
                color="primary"
                isLoading={isLoading}
                subTitle={t("pricePerMonth", {
                    price: getOfferPrice(mobileOffer),
                })}
                title={mobileOffer.description}
                onClick={handleBannerButtonClick}
            />
        );

    return (
        <>
            <Helmet>
                <link href="https://shop.gomo.ie/mobile-sim-only" rel="canonical" />
                <meta content={t("mobilePageDescription")} name="description" />
                <meta content={t("mobilePageDescription")} property="og:description" />
                <meta content={t("mobilePageTitle")} property="og:title" />
                <meta content="width=device-width, initial-scale=1.0" name="viewport" />
                <meta content="index, follow" name="robots" />
                <title>{t("mobilePageTitle")}</title>
            </Helmet>
            {isTabletOrDesktop && renderHomeStickyBanner()}
            <Stack bgcolor="background.light" gap={isMobile ? 0 : 7} overflow="hidden">
                <HomeMobile
                    addBroadbandOfferState={addBroadbandOfferState}
                    broadbandCartOffer={broadbandCartOffer}
                    broadbandOffer={broadbandOffer}
                    closeBroadbandSidePanel={closeBroadbandSidePanel}
                    error={error}
                    handleAddBroadbandOffer={handleAddBroadbandOffer}
                    handleAddMobileOffer={handleAddMobileOffer}
                    handleDeleteBroadbandOffer={handleDeleteBroadbandOffer}
                    hasBroadbandOfferInCart={hasBroadbandOfferInCart}
                    hasMobileOfferInCart={hasMobileOfferInCart}
                    isBroadbandSidePanelOpen={isBroadbandSidePanelOpen}
                    isLoading={isLoading}
                    mobileOffer={mobileOffer}
                    mobileOfferCount={mobileOfferCount}
                    orderAuthorization={orderAuthorization}
                    retry={retry}
                />
                <HomeMobileReasonsToLove />
                <HomeMobileSwitchEasy />
                <HomeMarketingInformationBanner
                    actionButton={{
                        label: t("mobileMarketingInformation.button"),
                        onClick: () => push(ROUTES.BROADBAND_PAGE_URL),
                    }}
                    badgeLabel={t("mobileMarketingInformation.badge")}
                    description={t("mobileMarketingInformation.description")}
                    title={t("mobileMarketingInformation.title")}
                    variant={EServiceGroup.MOBILE}
                />
                <HomeMobileFrequentlyAskedQuestions />
            </Stack>
            {!isTabletOrDesktop && renderHomeStickyBanner()}
        </>
    );
};
